import axios from 'redaxios'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { DashboardAnalytics } from '../utilities/customAppHelpers'
import { parseValue } from '../../../utils/useStorageState'
import { getAnalytics } from '../../../api/internal/analytics'

const metricConfig = {
  pdvCountByDay: {
    metricName: 'pdvCountByDay',
    decorator: (v: number) => {
      return v * 1000
    },
  },
}

export const getDashboardAnalytics = (
  appId: string,
  environmentId: string,
  startDate: string,
  endDate: string,
  metrics: string
) => {
  const token = parseValue(localStorage.getItem('token'))
  axios.defaults.headers = { ...axios.defaults.headers, Authorization: `Bearer ${token}` }

  const {
    data: analytics,
    isError: isGetAppStatsError,
    isLoading: isGetAppStatsLoading,
  } = useQuery({
    queryKey: ['getDashboardAnalytics', appId, environmentId, startDate, endDate, metrics],
    queryFn: () => getAnalytics({ appId, environmentId, startDate, endDate, metrics }),
  })

  const [analyticData, total]: [DashboardAnalytics[], number] = useMemo(() => {
    if (!analytics?.data.data) {
      return [[], 0]
    }

    const { data, totals } = analytics.data
    const selectedMetricConfig = metricConfig[metrics as keyof typeof metricConfig]

    if (!selectedMetricConfig) {
      return [data, totals[metrics]]
    }

    const { metricName, decorator } = selectedMetricConfig

    return [
      data.map((item: DashboardAnalytics) => ({
        ...item,
        metricValue: decorator(item.metricValue),
      })),
      decorator(totals[metricName]),
    ]
  }, [analytics?.data.data, metrics])

  return {
    analyticData,
    total,
    isGetAppStatsError,
    isGetAppStatsLoading,
  }
}
